import React from 'react';

import TranslationFormattedMessage from 'utils/TranslationFormattedMessage';

import clockIcon from './clockIcon.svg';
import './MoreMarketsPlaceholder.scss';

const MoreMarketsPlaceholder = () => (
  <div className='more-markets-placeholder'>
    <img
      className='more-markets-placeholder__icon'
      src={clockIcon}
      alt='Clock'
    />
    <span className='more-markets-placeholder__title'>
      <TranslationFormattedMessage id='t_odds_panel_markets_coming_soon_p1' />
    </span>
    <span className='more-markets-placeholder__highlighted'>
      <TranslationFormattedMessage id='t_odds_panel_markets_coming_soon_p2' />
    </span>
    <span className='more-markets-placeholder__description'>
      <TranslationFormattedMessage id='t_odds_panel_markets_updating' />
    </span>
  </div>
);

export default MoreMarketsPlaceholder;
